module.exports = __webpack_public_path__ + "img/donut.48a91be6.svg";